import Fetch from "utils/fetch";

export const searchOrdersStatus = () => {
  return Fetch.get('/orders:statuses').then(({ data }) => data)
}

export const searchOrdersVolumeStatus = () => {
  return Fetch.get('/volume-orders/status').then(({ data }) => data)
}

export const searchOrdersNegotiationTypes = () => {
  return Fetch.get('/orders:negotiation-types').then(({ data }) => data)
}
